import axios from "axios";
import { HaywireUrlsInterface } from "../../shared/Interfaces/globalContextInterface";

export const userPreferences = async (
	requestToken: string,
	haywireUrls: HaywireUrlsInterface | null,
	deviceUuid: string,
): Promise<any> => {
	if (!requestToken) return null;

	try {
		const response = await axios.get(
			`${haywireUrls?.identity_base_url}${haywireUrls?.identity_api_version}/preferences`,
			{
				headers: {
					"X-Session": requestToken,
					"X-API-Key": haywireUrls?.identity_api_key || "",
					"X-Device-UUID": deviceUuid || haywireUrls?.device_uuid,
				},
			},
		);

		return {
			data: response?.data,
		};
	} catch (e) {
		console.error("userPreferences -> error", e);
	}

	return null;
};
